import { Type } from 'class-transformer';
import { DimensionOptionCodeRawDto } from '../../common/dimensions/dimension-option-code-raw-dto';

export class APCreditApplicationEditorParameterDto {
    managementCompanyId: number;
    communityId: number;
    transactionId: number;

    @Type(() => DimensionOptionCodeRawDto)
    requiredDimensions: Array<DimensionOptionCodeRawDto>;
}
